// Shared telemetry state for an open InquirySheet session.
// Set by InquiryForm during its lifetime, read by InquirySheet on close.

export interface InquirySheetTelemetry {
  hadFieldFocus: boolean;
  firstFieldFocused: string | null;
  maxScrollDepth: number; // 0–100
}

const state: InquirySheetTelemetry = {
  hadFieldFocus: false,
  firstFieldFocused: null,
  maxScrollDepth: 0,
};

export const resetInquirySheetTelemetry = () => {
  state.hadFieldFocus = false;
  state.firstFieldFocused = null;
  state.maxScrollDepth = 0;
};

export const getInquirySheetTelemetry = (): InquirySheetTelemetry => ({ ...state });

export const setInquirySheetFieldFocus = (fieldName: string) => {
  if (!state.hadFieldFocus) {
    state.hadFieldFocus = true;
    state.firstFieldFocused = fieldName;
  }
};

export const setInquirySheetScrollDepth = (depth: number) => {
  if (depth > state.maxScrollDepth) state.maxScrollDepth = depth;
};
